<template>
  <div class="sort-dropdown" ref="wrapper">
    <button
      type="button"
      class="sort-dropdown__toggle"
      :aria-expanded="open"
      @click="open = !open"
    >
      {{ currentLabel }}
      <span class="sort-dropdown__arrow" :class="{ 'sort-dropdown__arrow--open': open }"><i class="mdi mdi-chevron-down" aria-hidden="true"></i></span>
    </button>

    <ul v-if="open" class="sort-dropdown__menu" role="listbox">
      <li
        v-for="option in options"
        :key="option.value"
        class="sort-dropdown__item"
        :class="{ 'sort-dropdown__item--active': option.value === modelValue }"
        role="option"
        :aria-selected="option.value === modelValue"
        @click="select(option.value)"
      >
        {{ option.label }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "SortDropdown",

  props: {
    modelValue: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
  },

  emits: ["update:modelValue"],

  data() {
    return {
      open: false,
    };
  },

  computed: {
    currentLabel() {
      const found = this.options.find((o) => o.value === this.modelValue);
      return found ? found.label : "";
    },
  },

  mounted() {
    document.addEventListener("click", this.handleOutsideClick);
  },

  beforeUnmount() {
    document.removeEventListener("click", this.handleOutsideClick);
  },

  methods: {
    select(value) {
      this.$emit("update:modelValue", value);
      this.open = false;
    },
    handleOutsideClick(event) {
      if (this.$refs.wrapper && !this.$refs.wrapper.contains(event.target)) {
        this.open = false;
      }
    },
  },
};
</script>
